<div class="sdps-p-horizontal_medium">
  <sdps-notification type="information" class="sdps-m-top_none" *ngIf="showClientMsg">
    <p class="sdps-notification__text" [innerHTML]="getShellConstant.noCientSelected"></p>
  </sdps-notification>
</div>
<div class="sdps-p-horizontal_medium" *ngIf="!showClientMsg">
    <form [formGroup]="reportDetails" >
      <div class="sdps-grid-container sdps-wrap report-dropdown">

        <div class="sdps-row sdps-p-top_large">
          <span class="sdps-m-right_small">
            <p-radioButton class="emtr-radio ems-inline" inputId="snapShot" name="selectedButtonType" formControlName="selectedButtonType"
              value="{{getShellConstant.reports.RulesDetails.snapShot}}" (ngModelChange)="editSnapshotHistory()"></p-radioButton>
            <label class="sdps-p-left_x-small" for="snapShot">{{getShellConstant.reports.RulesDetails.snapShot}}</label>
          </span>
          <span>
            <p-radioButton class="emtr-radio ems-inline" inputId="history" name="selectedButtonType" formControlName="selectedButtonType"
              value="{{getShellConstant.reports.RulesDetails.historyTxt}}" (ngModelChange)="editSnapshotHistory()"></p-radioButton>
            <label class="sdps-p-left_x-small" for="history">{{getShellConstant.reports.RulesDetails.historyTxt}}</label>
          </span>
        </div>

        <div class="sdps-row sdps-p-top_x-large" *ngIf="!snapshotSelected">
          <div class="display-flex">
            <app-report-from-to-datepicker (calendarValidation)="calendarValidation($event)" [dateRange]="90" [initialDateRange]="7" (getEmittedVal)="setDate($event)"
                                           [calendarForm]="reportDetails" (throwDateError)="throwDateError($event)" (throwDateRangeError)="throwDateRangeError($event)"></app-report-from-to-datepicker>
          </div>
        </div>
        <div class="sdps-row sdps-display-inline-block sdps-p-top_large">
          <div class="col-3 sdps-p-left_none sdps-p-right_small request-list-filter addlink-report-multi-dropdown">
            <p [innerHTML]="getShellConstant.reports.RulesDetails.ruleType"></p>
            <label class="sr-only" for="selectedRuleType">{{getShellConstant.reports.RulesDetails.ruleType}}</label>
            <p-multiSelect inputId="selectedRuleType" appendTo="body" [attr.aria-label]="getShellConstant.reports.RulesDetails.ruleType" [panelStyleClass]="ruleTypes?.length > 5 ? 'multiselect-dropdown' : ''" [options]="ruleTypes" placeholder="Rule Type" [defaultLabel]="' '" formControlName="selectedRuleType"
                           [displaySelectedLabel]= "true" [maxSelectedLabels]= "1" [filterPlaceHolder]="'All'"
                           [filter]="true" [showHeader]="true" optionLabel="name">
            </p-multiSelect>
        </div>
          <div class="col-3 sdps-p-left_none sdps-p-right_small request-list-filter addlink-report-multi-dropdown">
            <p [innerHTML]="getShellConstant.reports.RulesDetails.subTypeTxt"></p>
            <label class="sr-only" for="selectedAppliesTo">{{getShellConstant.reports.RulesDetails.subTypeTxt}}</label>
            <p-multiSelect inputId="selectedAppliesTo" appendTo="body" [attr.aria-label]="getShellConstant.reports.RulesDetails.subTypeTxt" [panelStyleClass]="appliesTo?.length > 5 ? 'multiselect-dropdown' : ''" [options]="appliesTo" [defaultLabel]="' '" formControlName="selectedAppliesTo"
                           [displaySelectedLabel]= "true" [maxSelectedLabels]= "1" [filterPlaceHolder]="'All'"
                           [filter]="true" [showHeader]="true" optionLabel="name">
            </p-multiSelect>
          </div>
          <div class="col-3 sdps-p-left_none sdps-p-right_small request-list-filter addlink-report-multi-dropdown">
            <p [innerHTML]="getShellConstant.reports.RulesDetails.ruleStatus"></p>
            <label class="sr-only" for="selectedRuleStatus">{{getShellConstant.reports.RulesDetails.ruleStatus}}</label>
            <p-multiSelect inputId="selectedRuleStatus" appendTo="body" [attr.aria-label]="getShellConstant.reports.RulesDetails.ruleStatus" [panelStyleClass]="ruleStatus?.length > 5 ? 'multiselect-dropdown' : ''" [options]="ruleStatus" [defaultLabel]="' '" formControlName="selectedRuleStatus"
                           [displaySelectedLabel]= "true" [maxSelectedLabels]= "1" [filterPlaceHolder]="'All'"
                           [filter]="true" [showHeader]="true" optionLabel="name">
            </p-multiSelect>
          </div>
        </div>

        <div class="sdps-row sdps-p-top_large select-report-type">
          <div class="col-3 sdps-p-left_none">
            <div
            [ngClass]="{'invalidField': (reportDetails.get('tradeSymbol').value && reportDetails.get('tradeSymbol').invalid), 'disabled-grey': reportDetails.get('tradeSymbol').disabled}">
              <p-float-label variant="in">
                <input type="text" id="tradeSymbol" name="tradeSymbol" [maxlength]="100" formControlName="tradeSymbol" emsAlphaNumericSpecialCharacterValidation pInputText/>
                <label for="tradeSymbol" [innerHTML]="getShellConstant.reports.RulesDetails.symbol"></label>
              </p-float-label>
            </div>
          </div>
          <div class="col-3 sdps-p-left_none">
            <div
            [ngClass]="{'invalidField': (reportDetails.get('cusipSymbol').value && (reportDetails.get('cusipSymbol').invalid || reportDetails.get('cusipSymbol').value.length < 9)), 'disabled-grey': reportDetails.get('cusipSymbol').disabled}">
              <p-float-label variant="in">
                <input type="text" id="cusipSymbol" name="cusipSymbol" emsAlphaNumericSpecialCharacterValidation [maxlength]="9" formControlName="cusipSymbol" pInputText/>
                <label for="cusipSymbol" [innerHTML]="getShellConstant.reports.RulesDetails.cusip"></label>
              </p-float-label>
            </div>
          </div>

          <div class="col-3 sdps-p-left_none">
            <div class="sdps-p-left_none sdps-dropdown--lightGrey emtr-dropdown employee-dropdown dropdown-width employee-association-dropdown report-groupname">
              <p-floatlabel variant="in">
                <ems-lazy-load-dropdown [id]="'empGroupName'" [name]="'empGroupName'" [orgID]="orgID" [dropdownName]="'groupName'"
                  [businessUnit]="businessUnit" [resetToken]="groupDropdownResetToken" [ariaLabel]="sharedConstant[businessUnit].enterGroupOrPlanName"
                  (ngModelGroupChange)="groupNameUpdated($event)"></ems-lazy-load-dropdown>
                <label for="empGroupName" [innerHTML]="sharedConstant[businessUnit].enterGroupOrPlanName"></label>
              </p-floatlabel>
            </div>
          </div>
        </div>

      </div>
    </form>
    <ems-step-wizard-buttons [showCancelBtn]="true" (closeBtn)="cancelReport()" [showRunReportBtn]="true" (runReport)="runReports()"
                             [disableBtn]="reportDetails.invalid || endDateLessThanStartDate || dateError || (reportDetails.get('cusipSymbol').value && reportDetails.get('cusipSymbol').value.length < 9)"></ems-step-wizard-buttons>
</div>
